export enum WidgetOpportunityPerformanceEnum {
    LEADS_REGISTERED = 'LEADS_REGISTERED',
    LEADS_CONTACTED = 'LEADS_CONTACTED',
    EVALUATIONS_REGISTERED = 'EVALUATIONS_REGISTERED',
    EVALUATIONS_CONCLUDED = 'EVALUATIONS_CONCLUDED',
    EVALUATIONS_CREATED = 'EVALUATIONS_CREATED',
}
